import React, { FC } from 'react';
import DataRoomDocHeader from '../DataRoomDocHeader';
import DataRoomDocList from '../DataRoomDocList';
import { DataRoomDocListProps } from '../DataRoomDocList/DataRoomDocList.component';
import useMatchMedia from 'hooks/useMatchMedia';

const DataRoomContent: FC<DataRoomDocListProps> = (props) => {
  const isPhablet = useMatchMedia('isPhablet');

  return (
    <>
      {!isPhablet && <DataRoomDocHeader />}
      <DataRoomDocList {...props} />
    </>
  );
};

export default DataRoomContent;
